import React, { useEffect } from 'react';
import useForms from '../../../hooks/forms';
import useHttp from '../../../hooks/http';
import AUX from '../../../hoc/AU-X/AU-X';
import CInput from '../../UI/CInput/CInput';
import CButton from '../../UI/FCButton/FCButton';
import SimpleFrame from '../../UI/SimpleFrame/SimpleFrame';
import './Forms.scss';

const FormsBoilerplate = (props) => {
  const { inputs, body, url, handleResponse, pageTitle, header, beforeForm, btnStyle, btnText, method, notjson } =
    props;
  const { clearAll, theForm, formIsValid, onChangeHandler, inputOnBlur, setMessage, findErrorAndShow } = useForms();
  const { isLoading, data, error, sendRequest, clear } = useHttp();

  useEffect(() => {
    clearAll(inputs);
  }, [inputs, clearAll]);

  useEffect(() => {
    if (!isLoading && !error && data) {
      console.log(data);

      if (handleResponse) {
        handleResponse(data, setMessage);
      } else {
        setMessage({
          message: data.message,
          type: data.status,
        });
      }

      clear();
    }
  }, [error, isLoading, data, clear, handleResponse, setMessage]);

  const formSubmit = (event) => {
    event.preventDefault();

    if (!formIsValid) {
      findErrorAndShow();
      return;
    }

    let requestBody = { ...body };
    let finalUrl = url;
    let val;

    theForm.forEach((element) => {
      if (element.queryParams) {
        if (finalUrl.indexOf('?') > -1) {
          finalUrl += '&';
        } else {
          finalUrl += '?';
        }

        val = element.requestValue ? element.requestValue : element.value;
        finalUrl += element.id + '=' + val;
      } else {
        if (element.single) {
          requestBody = element.value;
        } else {
          requestBody[element.id] = element.requestValue ? element.requestValue : element.value;
        }
      }

      element.AfterInputs &&
        element.AfterInputs[element.indexValue].forEach((e) => {
          requestBody[e.id] = e.requestValue ? e.requestValue : e.value;
        });
    });

    sendRequest(
      finalUrl,
      method ?? 'POST',
      Object.keys(requestBody).length > 0 ? JSON.stringify(requestBody) : null,
      header,
      notjson
    );
  };

  return (
    <SimpleFrame NotCenter>
      {beforeForm}
      <form className='formsBoilerplate center' onSubmit={formSubmit}>
        <h2>{pageTitle}</h2>

        {theForm ? (
          theForm.map((inputs, index) => (
            <AUX key={inputs.id}>
              <CInput
                direction={!inputs.direction && 'rtl'}
                config={inputs.elementConfig}
                value={inputs.value}
                validBoxShadow={!inputs.valid && inputs.touched}
                changed={(event) => onChangeHandler(event, index)}
                blured={() => inputOnBlur(index)}
              />
              {inputs.AfterInputs &&
                inputs.indexValue !== -1 &&
                inputs.AfterInputs[inputs.indexValue].map((afterInputs, afterIndex) => (
                  <CInput
                    key={afterInputs.id}
                    direction={!afterInputs.direction && 'rtl'}
                    config={afterInputs.elementConfig}
                    value={afterInputs.value}
                    validBoxShadow={!afterInputs.valid && afterInputs.touched}
                    changed={(event) => onChangeHandler(event, index, inputs.indexValue, afterIndex)}
                    blured={() => inputOnBlur(index, inputs.indexValue, afterIndex)}
                  />
                ))}
            </AUX>
          ))
        ) : (
          <p>این صفحه موجود نیست</p>
        )}

        {theForm && (
          <CButton style={btnStyle} ready={formIsValid}>
            {btnText ? btnText : 'ثبت'}
          </CButton>
        )}
      </form>
    </SimpleFrame>
  );
};

export default FormsBoilerplate;
